import useEventEmitter, { EventEmitter } from 'ahooks/lib/useEventEmitter';
import { atom } from 'jotai';

export const emitterAtom = atom<EventEmitter<any>>(new EventEmitter<any>());

export const asyncEmitterAtom = atom(null, async (get, set) => {
  const emitter = get(emitterAtom);
  if (emitter) return emitter;
  const new_emitter = useEventEmitter();
  set(emitterAtom, new_emitter);
});
